<template>
  <div class="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
    <div
      v-for="illustration in availableIllustrations"
      :key="illustration.name"
      class="illustration-item flex flex-col items-center justify-center rounded-md border p-3 transition-all"
      :class="[
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        {
          'border-gray-200 hover:border-blue-500':
            modelValue.icon !== illustration.name && !disabled,
          'border-2 border-blue-500': modelValue.icon === illustration.name,
        },
      ]"
      data-cy="illustration-item"
      @click="selectIllustration(illustration.name)"
    >
      <component
        :is="illustration.component"
        class="h-16 w-28 overflow-hidden px-5"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, toRef } from "vue";

import illustrations from "@/components/icons/borrowerPlatform/borrowerTabs/illustrations";
import { useBlockEdit } from "@/composables/useBlockEdit";

import type { BaseBlockProps } from "@/models/borrowerPlatformTemplates";

const { modelValue, disabled = false } = defineProps<
  BaseBlockProps & {
    disabled?: boolean;
  }
>();

const { updateBlock } = useBlockEdit(toRef(() => modelValue));

const availableIllustrations = computed(() =>
  Object.entries(illustrations).map(([name, component]) => ({
    name,
    component,
  }))
);

const selectIllustration = (iconName: string) => {
  if (disabled) {
    return;
  }
  updateBlock("icon", iconName);
};
</script>
